import "./styles.css"
const SlickCarouselArrow = ({ side, onClick, className }) => {
  return (
    <div
      className={`${
        className ?? ""
      } shadow-md rounded-lg custom-slick-arrow cursor-pointer`}
      onClick={onClick}
      style={{
        [side]: "-0.75rem",
      }}
    >
      <i className={`fas fa-angle-${side} text-gray-700`} />
    </div>
  )
}

export default SlickCarouselArrow
